// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AttentionExample } from './attentionExample.zod.ts';

export const attentionCountExamplesDefault = [];

export const AttentionCount = zod.object({
  "count": zod.int(),
  "examples": zod.array(AttentionExample).default(attentionCountExamplesDefault)
});

export type AttentionCount = zod.input<typeof AttentionCount>;
export type AttentionCountOutput = zod.output<typeof AttentionCount>;
